/**
 * Session from Electron main after /api/desktop/config (via ?tt-bootstrap= query).
 */

/**
 * @returns {{ baseUrl: string, config: object } | null}
 */
export function readEmbeddedDesktopBootstrap() {
  if (typeof window === 'undefined') return null;
  if (window.__TWIN_TALES_BOOTSTRAP__?.baseUrl) {
    return window.__TWIN_TALES_BOOTSTRAP__;
  }
  try {
    const raw = new URLSearchParams(window.location.search).get('tt-bootstrap');
    if (!raw) return null;
    const session = JSON.parse(decodeURIComponent(raw));
    if (session?.baseUrl) {
      window.__TWIN_TALES_BOOTSTRAP__ = session;
      return session;
    }
  } catch {
    // ignore
  }
  return null;
}
